module.exports = __webpack_public_path__ + "img/378.423360a3.png";